const rawJson = document.querySelector('#variant_update-data');
const variantsData = JSON.parse(rawJson.textContent);
const productForm = document.querySelector('product-info section.product-form');

subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
    const activeVariant = event.data.selectedOptionNames.join('/');
    updateVariantInfo(activeVariant);
});

function updateVariantInfo(activeTitle) {
    if (!activeTitle || !variantsData) return;
    const normalize = (str) =>
        str.toLowerCase().replace(/\s*\/\s*/g, " / ").replace(/\s+/g, ' ').trim();

    const normalizedTitle = normalize(activeTitle);
    const keys = Object.keys(variantsData);
    const matchedKey = keys.find(k => normalize(k) === normalizedTitle);
    const variant = variantsData[matchedKey];
    const { available, policy, stock } = variant;

    if (policy === "continue" && available === true && stock <= 1) {
        productForm.classList.add('variant-in_stock');
        productForm.classList.remove('variant-sold_out');
        //console.log('success');
    } else {
        productForm.classList.add('variant-sold_out');
        productForm.classList.remove('variant-in_stock');
        //console.log('failed');
    }
}